export default {
    top_menu: [
        {name:'Die Hauptsache',    id:0},
        {name:'Show-business', id:1},
        {name:'Kochen',  id:2},
        {name:'Politik',   id:3},
        {name:'+18',  id:4},
        {name:'Die Gesellschaft',   id:5},
        {name:'Gesundheit',   id:6},
    ],
    read_other: 'weiter lesen',
    read_more:  'Mehr Details',
    not_found:  'Nichts gefunden',
    read_also:  'Lesen Sie auch',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Alle Rechte vorbehalten.',
    subscribe: 'Jetzt abonnieren',

    thank_order: 'DANKE FÜR IHRE BESTELLUNG',
    specialist_contact: 'Unser Spezialist wird sich in Kürze mit Ihnen in Verbindung setzen, warten Sie auf unseren Anruf.',
    attention: 'Rabatte von Partnern:',
    hurry: 'Beeilen Sie sich, die Aktivierungszeit des Rabatts ist begrenzt! Sie haben nur <span id="time" class="time">30:00</span> Minuten Zeit, sich für eines dieser einzigartigen Produkte zu entscheiden:',

    hour_ago1: "vor einer Stunde",
    hour_ago2: "Vor Stunden",
    hour_ago3: "Vor Stunden",
    new_publications: "Neue Veröffentlichungen",
    read: "Lesen",
    today_at: "Heute um",
    author_names: ['Heidi Kaulitz','Till Lindemann','Diane Kruger'],
    main_news: "Hauptnachrichten",
    leave_already: "Schon verlassen? Warten Sie, wir haben die Neuigkeiten für Sie aktualisiert",
    already_shared: "schon geteilt"

}